const EASTERN_TZ = 'America/Toronto';

export function formatOrderNumber(order) {
  return (order?.order_number || order?.order_id?.slice(-6) || '').toUpperCase();
}

export function formatOrderNumberLabel(order) {
  const num = formatOrderNumber(order);
  return num ? `#${num}` : '';
}

/** YYYY-MM-DD in America/Toronto for an ISO datetime. */
export function easternDateKey(isoOrDate, now = new Date()) {
  const d = isoOrDate instanceof Date ? isoOrDate : new Date(isoOrDate || now);
  if (Number.isNaN(d.getTime())) return null;
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: EASTERN_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(d);
}

export function isPickupTodayOrEarlier(order, now = new Date()) {
  const pickupKey = easternDateKey(order?.scheduled_pickup_time);
  const todayKey = easternDateKey(now);
  if (!pickupKey || !todayKey) return true;
  return pickupKey <= todayKey;
}

export function isPickupAfterToday(order, now = new Date()) {
  const pickupKey = easternDateKey(order?.scheduled_pickup_time);
  const todayKey = easternDateKey(now);
  if (!pickupKey || !todayKey) return false;
  return pickupKey > todayKey;
}

/**
 * Accept-SLA clock starts at max(created_at, start of pickup day Eastern).
 * Returns a Date for the deadline (anchor + timeoutMin minutes).
 */
export function vendorApprovalDeadline(order, timeoutMin = 15) {
  const createdMs = order?.created_at ? new Date(order.created_at).getTime() : 0;
  const pickup = order?.scheduled_pickup_time ? new Date(order.scheduled_pickup_time) : null;
  let startOfDayMs = 0;
  if (pickup && !Number.isNaN(pickup.getTime())) {
    const parts = Object.fromEntries(
      new Intl.DateTimeFormat('en-US', {
        timeZone: EASTERN_TZ,
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hourCycle: 'h23',
      })
        .formatToParts(pickup)
        .filter((p) => p.type !== 'literal')
        .map((p) => [p.type, Number(p.value)])
    );
    const msIntoDay =
      ((parts.hour || 0) * 3600 + (parts.minute || 0) * 60 + (parts.second || 0)) * 1000;
    startOfDayMs = pickup.getTime() - msIntoDay;
  }
  const anchor = Math.max(createdMs || 0, startOfDayMs || 0);
  if (!anchor) return null;
  return new Date(anchor + timeoutMin * 60 * 1000);
}

export function formatEasternPickupDate(order) {
  if (!order?.scheduled_pickup_time) return '';
  return new Date(order.scheduled_pickup_time).toLocaleDateString('en-CA', {
    timeZone: EASTERN_TZ,
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
}
